var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading || _vm.swiperIsVisible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "view",
              rawName: "v-view",
              value: _vm.bulkLoadAllCarouselProducts,
              expression: "bulkLoadAllCarouselProducts",
            },
          ],
          ref: "carouselRoot",
          staticClass:
            "rb-featured-products-carousel m-dynamic--x m-dynamic--mobile-no-bleed",
          attrs: { id: _vm.id },
        },
        [
          _c(
            "div",
            { staticClass: "rb-featured-products-carousel__images-gallery" },
            [
              _vm.textModuleIsVisible
                ? _c("rb-text-module", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title_block",
                          fn: function () {
                            return [_vm._t("title")]
                          },
                          proxy: true,
                        },
                        {
                          key: "excerpt_block",
                          fn: function () {
                            return [_vm._t("description")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.swiperIsVisible
                ? _c(
                    "swiper",
                    {
                      ref: "swiperRef",
                      attrs: {
                        config: _vm.defaultConfig,
                        navigation: _vm.enableSwiperArrows,
                        pagination: true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "navigationprev",
                            fn: function () {
                              return [
                                _c("rb-lazy-icon", {
                                  attrs: { icon: "caret-light-left" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "navigationnext",
                            fn: function () {
                              return [
                                _c("rb-lazy-icon", {
                                  attrs: { icon: "caret-light-right" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3867750212
                      ),
                    },
                    _vm._l(_vm.products, function (product, index) {
                      return _c(
                        "swiper-slide",
                        { key: index },
                        [
                          !_vm.isInMinicart
                            ? _c("rb-product-tile", {
                                attrs: {
                                  product: product,
                                  "data-element-id":
                                    "Recommendations_Tile" + index,
                                  "data-description":
                                    _vm.getDataDescription(product),
                                  "add-to-cart":
                                    _vm.hasAddToBag &&
                                    _vm.correlatedProductsAvailability &&
                                    _vm.correlatedProductsAvailability[
                                      product.catEntryId
                                    ] &&
                                    _vm.correlatedProductsAvailability[
                                      product.catEntryId
                                    ].isAddToBagEnabled
                                      ? _vm.createAddToCart(product.catEntryId)
                                      : null,
                                  "is-hover-effect-enabled": false,
                                  "add-to-bag-data-element-id":
                                    "Recommendations_Tile" + index + "_cartAdd",
                                  "is-in-minicart": _vm.isInMinicart,
                                },
                                on: { addToCart: _vm.addToCart },
                              })
                            : _c("rb-cross-selling-tile", {
                                attrs: {
                                  product: product,
                                  "data-element-id":
                                    "Recommendations_Tile" + index,
                                  "data-description":
                                    _vm.getDataDescription(product),
                                  "add-to-cart":
                                    _vm.hasAddToBag &&
                                    _vm.correlatedProductsAvailability &&
                                    _vm.correlatedProductsAvailability[
                                      product.catEntryId
                                    ] &&
                                    _vm.correlatedProductsAvailability[
                                      product.catEntryId
                                    ].isAddToBagEnabled
                                      ? _vm.createAddToCart(product.catEntryId)
                                      : null,
                                  "is-hover-effect-enabled": false,
                                  "add-to-bag-data-element-id":
                                    "Recommendations_Tile" + index + "_cartAdd",
                                  "is-in-minicart": _vm.isInMinicart,
                                },
                                on: { addToCart: _vm.addToCart },
                              }),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoading
                ? _c("rb-loading", { attrs: { loading: true } })
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }